export const customersActionTypes = {
	GET_ALL_CUSTOMERS: "GET_ALL_CUSTOMERS",
	GET_SINGLE_CUSTOMER: "GET_SINGLE_CUSTOMER",
};
